// Sitets EGEN del af tegn-CSV-eksporten: kolonnenavnene og kortlægningen fra panelets
// rækker. Selve serialiseringen (profiler, quoting, formel-vagt, BOM) bor i det vendorede
// modul frontend/src/vendor/csv/index.js og må ALDRIG genopfindes her.
//
// Delingen er med vilje: modulet kender ikke kyws datamodel, og kyw kender ikke RFC 4180.
// Filen er lille nok til at kunne læses i ét blik, og den kan importeres af `node --test`
// (ingen DOM), så testen vogter præcis den kolonnerækkefølge og den kortlægning der
// faktisk sendes med i bundlen (tests/test-tegn-csv.mjs).

export const TEGN_CSV_KOLONNER = [
  'tegn', 'segment', 'kinesisk', 'dansk', 'funktion', 'note', 'status', 'linje_zh', 'linje_da',
];

/**
 * Kortlæg panelets eksport-rækker (output fra tegn-panelets eksportRaekker) til den
 * rækkeform csvText forventer: ét objekt pr. række med kolonnenavnene som nøgler.
 *
 * dansk er null når forekomsten ingen dansk gengivelse har; zhLine/daLine er null når
 * positionen ikke kunne opløses. Alle tre bliver til TOMME celler, ikke teksten "null".
 * Linjenumrene beregnes af kalderen KUN ved eksport-tidspunktet – positions-afledte
 * felter må aldrig indgå i panelets cache-nøgler (fejlen gate-runden 2026-07-29 rettede).
 */
export function tegnCsvRows(rows) {
  return (rows || []).map((r) => ({
    tegn: r.tegn,
    segment: r.segment,
    kinesisk: r.kinesisk,
    dansk: r.dansk == null ? '' : r.dansk,
    funktion: r.funktion,
    note: r.note,
    status: r.status,
    linje_zh: r.zhLine == null ? '' : r.zhLine,
    linje_da: r.daLine == null ? '' : r.daLine,
  }));
}
